export default __webpack_public_path__ + "static/media/pro-360-img.5b93b4d3.png";